import React from 'react';
import styled from 'styled-components';

const HideAbleDiv = styled.div`
  ${({display}) => display === false && `display: none`};
`;

export default HideAbleDiv;

